import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { ThemeButton } from "../../components/buttons/ThemeButton";
import Langs from "../../app/lang/langs";
import { SelectInput } from "../../components/inputs/Select";
import { TransparentDatePicker } from "../../components/buttons/TransparentDatePicker";
import { getLeaves, requestDeleteLeave, requestLeave } from "./leavesSlice";
import { checkPermission, generateUniqueId, getLastUpdatedFromDate, getTagClass, isOwner, showSuccessToast } from "../../app/utils/helpers";
import { DangerButton } from "../../components/buttons/DangerButton";
import { isAdmin } from "../../app/utils/helpers";
import { submitLeave } from "./leavesSlice";
import { showErrorToast } from "../../app/utils/helpers";
import { getPlanning } from "../planning/planningSlice";
import { Tag } from "primereact/tag";
import { Message } from 'primereact/message';
import moment from "moment-timezone";
import { getCollabs } from "../../components/collabs/collabsSlice";
import { config } from "../../app/utils/config";

export function LeaveFormModal(props) {

    const dispatch = useDispatch()

    const userId = useSelector((state) => state.login.userId)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const userCollabId = useSelector((state) => state.login.userId)
    const teams = useSelector((state) => state.teams.list)
    const currentCollabs = useSelector((state) => state.collabs.currentList)
    const myTeam = useSelector((state) => state.teams.myTeam)
    const sampleLeaves = useSelector((state) => state.sampleLeaves.list)
    const leaveModalType = useSelector((state) => state.leaves.leaveModalType)
    const selectedLeaveFormData = useSelector((state) => state.leaves.selectedLeaveFormData)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const collabs = useSelector((state) => state.collabs.list)

    const [formError, setFormError] = useState(null)
    const [selectedCollab, setSelectedCollab] = useState()
    const [formData, setFormData] = useState({})
    const [showToDate, setShowToDate] = useState(false)
    const [leavesOptions, setLeavesOptions] = useState([])
    const [timezone, setTimezone] = useState(config.timezone)

    const mounted = useRef(false)

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
            setNewFormData()
            setSelectedCollab(null)
        }
    })

    useEffect(() => {
        loadLeaves()
    }, [dispatch, collabs])

    useEffect(() => {
        if (selectedLeaveFormData && teams) {
            let team = teams.find(t => t.id == selectedLeaveFormData.id_team)
            if (team) {
                switch (team.id_country) {
                    case 3:
                        //setTimezone("Indian/Mauritius")
                        break
                    default:
                        break
                }
            }
        }
    }, [selectedLeaveFormData, teams])

    function setNewFormData() {

        let from = moment().tz(timezone).startOf("day")
        let to = moment().tz(timezone).endOf("day")

        let leaveData = {
            id: generateUniqueId(),
            id_team: null,
            id_collab: null,
            id_sample_leave: null,
            type: null,
            from: parseInt(from.format("x")),
            to: parseInt(to.format("x")),
            description: null
        }
        setFormData(leaveData)
    }

    function getFromDayPeriodOptions() {
        let options = [
            { value: 0, label: <Langs str="Matin" /> },
            { value: 12, label: <Langs str="Midi" /> }
        ]
        return options
    }

    function getCollabsOptions() {
        let uniqueIds = []
        let collabsOptions = currentCollabs.filter((collab) => {
            return ["Présent", "Actif"].includes(collab.statut)
                && (!myTeam || checkPermission(config.scopes.leaves, config.permissionTypes.edit, collab.id_team) || collab.id_team != myTeam.id || collab.id == userCollabId)
                && !collab.id_team_delegate
        })
        return collabsOptions.filter(c => {
            if (uniqueIds.includes(c.id)) {
                return false
            }
            uniqueIds.push(c.id)
            return true
        })
    }

    function isManager() {
        let teamId = formData.id_team
        if (selectedLeaveFormData && leaveModalType == 'UPDATE_LEAVE')
            teamId = selectedLeaveFormData.id_team
        return checkPermission(config.scopes.leaves, config.permissionTypes.edit, teamId)
    }

    function getFromDayPeriod(value) {
        switch (value) {
            case 0:
                return "Matin"
            case 12:
                return "Midi"
            default:
                break
        }
    }

    function getToDayPeriodOptions() {
        let options = [
            { value: 12, label: <Langs str="Midi" /> },
            { value: 23, label: <Langs str="Soir" /> }
        ]
        return options
    }

    function getToDayPeriod(value) {
        switch (value) {
            case 12:
                return "Midi"
            case 23:
                return "Soir"
            default:
                break
        }
    }

    function getSelectedDayPeriod(dateTime) {
        
        let date = moment(dateTime, "x").tz(timezone)
        let hour = date.hours()
        if (hour < 12) return 0
        else if (hour > 12) return 23
        return 12
    }

    const onFromDayPeriodChange = (option) => {
        let fromDate = moment(formData.from, "x").tz(timezone).startOf("day")
        console.log(timezone, option.value)
        console.log(fromDate)
        if (option.value > 0) {
            fromDate.hours(option.value)
        }
        setFormData({ ...formData, from: parseInt(fromDate.format("x")) })
    }

    const onToDayPeriodChange = (option) => {
        let toDate = moment(formData.to).tz(timezone).hour(12).minute(0).second(0).millisecond(0)
        if (option.value > 12) {
            toDate = moment(formData.to).tz(timezone).endOf("day")
        }
        setFormData({ ...formData, to: parseInt(toDate.format("x")) })
    }

    function hide() {
        setNewFormData()
        setSelectedCollab(null)
        props.onHide()
    }

    function updateLeaveWithStatus(status) {
        dispatch(submitLeave({
            id: selectedLeaveFormData.id,
            status: status
        })).then((response) => {
            if (response['payload']['responseData']) {
                loadPlanning()
            }
            if (response['payload']['responseError']) {
                if (response['payload']['responseError']) {
                    if (response['payload']['responseError']['data'] && response['payload']['responseError']['data']['message']) {
                        showErrorToast(response['payload']['responseError']['data']['message'])
                    } else showErrorToast()
                }
            }
        })
        props.onHide()
    }

    function loadPlanning() {
        if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
            let selectedCollabsIds = collabs.reduce((array, current) => {
                array.push(current.id)
                return array
            }, [])
            dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }))
        }
    }

    function handleRequestDelete() {
        dispatch(requestDeleteLeave({ id: selectedLeaveFormData.id })).then((response) => {
            if (response['payload']['responseData']) {
                loadPlanning()
                if (selectedLeaveFormData["status"] != "PENDING")
                    showSuccessToast(<Langs str="REQUEST_SENT" />)
            }
            if (response['payload']['responseError']) {
                showErrorToast()
            }
        })
        props.onHide()
    }

    function handleSend() {
        // Vérification de la validité de la date de fin
        if (formData.from && formData.to && formData.to < formData.from) {
            setFormError("La date de fin ne peut pas être antérieure à la date de début");
            return;
        }
        if (!formData.id_collab) {
            setFormError("id_collab")
            return
        }
        if (!formData.id_sample_leave) {
            setFormError("id_sample_leave")
            return
        }
        setFormError(null)
        dispatch(requestLeave(formData)).then(() => {
            dispatch(getCollabs({ selectedTeamsIds, isCurrent: true }))
            hide()
        })

    }

    function loadLeaves() {
        if (selectedTeamsIds && selectedTeamsIds.length) {
            let selectedCollabsIds = collabs.reduce((array, current) => {
                array.push(current.id)
                return array
            }, [])
            dispatch(getLeaves({ selectedTeamsIds, selectedCollabsIds }))
        }
    }

    function handleCollabChange(collab) {
        // set collab's team timezone
        let collabTimezone = config.timezone
        switch (collab.id_country) {
            case 3:
                collabTimezone = "Indian/Mauritius"
                break
            default:
                break
        }

        setTimezone(collabTimezone)

        let availableLeaves = sampleLeaves.filter(s => !s.visibility && (!s.id_country || s.id_country == collab.id_country))

        if (!isAdmin(userRoleId)) {
            availableLeaves = availableLeaves.filter((sampleLeave) => sampleLeave.roleId >= 2)
        }

        if (collab.id != userId && !isOwner(userRoleId, collab.id_country)) {
            availableLeaves = availableLeaves.filter((sampleLeave) => sampleLeave.roleId < 3)
        }

        setSelectedCollab(collab)
        setLeavesOptions(availableLeaves)

        let from = moment().tz(collabTimezone).startOf("day")
        let to = moment().tz(collabTimezone).endOf("day")

        setFormData({
            ...formData,
            id_collab: collab.id,
            id_team: collab.id_team,
            id_sample_leave: availableLeaves[0].id,
            type: availableLeaves[0].type,
            from: parseInt(from.format("x")),
            to: parseInt(to.format("x"))
        })
    }

    function handleTypeChange(selectedSample) {
        setFormData({ ...formData, id_sample_leave: selectedSample.id, type: selectedSample.type })
    }

    const handleStartDateChange = (time) => {
        let selectedDate = moment(time, "x").tz(timezone)
        let formDate = moment(formData.from, "x").tz(timezone)
        formDate.year(selectedDate.year())
        formDate.month(selectedDate.month())
        formDate.date(selectedDate.date())
        setFormData({ ...formData, from: parseInt(formDate.format("x")) })
        setShowToDate(true)
    }


    const handleEndDateChange = (time) => {
        let selectedDate = moment(time, "x").tz(timezone)
        let toDate = moment(formData.to, "x").tz(timezone)
        toDate.year(selectedDate.year())
        toDate.month(selectedDate.month())
        toDate.date(selectedDate.date())
        setFormData({ ...formData, to: parseInt(toDate.format("x")) })
        setShowToDate(false)
    }

    const handleDescriptionChange = (event) => {
        setFormData({ ...formData, description: event.target.value })
    }

    function getLeaveLabel(leaveData) {
        if (leaveData.type == 'LEAVE') return <Langs str={leaveData.type} />
        let sampleLeave = sampleLeaves.filter(s => s.id == leaveData.id_sample_leave)
        if (sampleLeave[0]) return sampleLeave[0].description
        return ""
    }

    function renderBodyView() {
        if (selectedLeaveFormData && leaveModalType == 'UPDATE_LEAVE')
            return <Modal.Body>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="COLLAB" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <div>{selectedLeaveFormData && selectedLeaveFormData.collab}</div>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <span>
                            <Langs str="START" />
                        </span>
                    </Col>

                    <Col md={4}>
                        <div>{moment(selectedLeaveFormData.from).tz(timezone).format("DD MMMM YY")}</div>
                    </Col>

                    <Col md={5}>
                        <div><Langs str={getFromDayPeriod(getSelectedDayPeriod(selectedLeaveFormData.from))} /></div>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <span>
                            <Langs str="END" />
                        </span>
                    </Col>
                    <Col md={4}>
                        <div>{moment(selectedLeaveFormData.to).tz(timezone).format("DD MMMM YY")}</div>
                    </Col>
                    <Col md={5}>
                        <div><Langs str={getToDayPeriod(getSelectedDayPeriod(selectedLeaveFormData.to))} /></div>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="TYPE" />
                        </label>
                    </Col>

                    <Col md={9}>
                        <div><Langs str={selectedLeaveFormData.type} /></div>
                    </Col>
                </Row>
                {selectedLeaveFormData.description && <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="DESCRIPTION" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <div>{selectedLeaveFormData.description}</div>
                    </Col>
                </Row>}
                <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str="CREATED_AT" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <div>{getLastUpdatedFromDate(selectedLeaveFormData.createdAt) || "-"}</div>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str="CREATED_BY" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <div>{selectedLeaveFormData.createdBy}</div>
                    </Col>
                </Row>
            </Modal.Body>
        else if (leaveModalType == 'ADD_LEAVE')
            return <Modal.Body>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="COLLAB" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <SelectInput
                            value={formData.id_collab}
                            onChange={(e) => handleCollabChange(e)}
                            error={formError === "id_collab"}
                            options={getCollabsOptions()}
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <span>
                            <Langs str="START" />
                        </span>
                    </Col>
                    <Col md={4}>
                        <TransparentDatePicker
                            minDate={null}
                            onChange={handleStartDateChange}
                            value={formData.from}
                            timezone={timezone}
                        />
                    </Col>
                    <Col md={5}>
                        <SelectInput
                            options={getFromDayPeriodOptions()}
                            value={getSelectedDayPeriod(formData.from)}
                            onChange={onFromDayPeriodChange}
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <span>
                            <Langs str="END" />
                        </span>
                    </Col>
                    <Col md={4}>
                        <TransparentDatePicker
                            minDate={null}
                            onChange={handleEndDateChange}
                            value={formData.from}
                            range={formData.to}
                            forceShow={showToDate}
                            timezone={timezone}
                        />
                    </Col>
                    <Col md={5}>
                        <SelectInput
                            options={getToDayPeriodOptions()}
                            value={getSelectedDayPeriod(formData.to)}
                            onChange={onToDayPeriodChange}
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="TYPE" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <SelectInput
                            value={formData.id_sample_leave}
                            onChange={(e) => handleTypeChange(e)}
                            error={formError === "id_sample_leave"}
                            options={leavesOptions}
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-2">
                    <Col md={3}>
                        <label>
                            <Langs str="DESCRIPTION" />
                        </label>
                    </Col>
                    <Col md={9}>
                        <textarea
                            name="description"
                            maxLength={200}
                            value={formData.description || ""}
                            onChange={handleDescriptionChange}
                        />
                    </Col>
                </Row>
                {selectedCollab && <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str="CPN-1" />
                        </label>
                    </Col>
                    <Col md={9}>
                        {selectedCollab.solde_cp_old} <Langs str="days available till" /> {moment(selectedCollab.solde_cp_old_expiry).tz(timezone).format("DD/MM/YYYY")}
                    </Col>
                </Row>}
                {selectedCollab && <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str="CPN" />
                        </label>
                    </Col>
                    <Col md={9}>
                        {selectedCollab.solde_cp_current} <Langs str="days available" />
                    </Col>
                </Row>}
                {selectedCollab && leavesOptions.find(l => l.type == 'S') && <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str="Sick Leaves" />
                        </label>
                    </Col>
                    <Col md={9}>
                        {selectedCollab.solde_sick_leaves} <Langs str="days available" />
                    </Col>
                </Row>}
                {selectedCollab && leavesOptions.find(l => l.type == 'EXTRA') && <Row className="d-flex justify-content-center align-items-center p-2" style={{ color: "grey" }}>
                    <Col md={3}>
                        <label>
                            <Langs str={leavesOptions.find(l => l.type == 'EXTRA')?.description} />
                        </label>
                    </Col>
                    <Col md={9}>
                        {selectedCollab.solde_extra_leaves} <Langs str="days available" />
                    </Col>
                </Row>}
                <Row className='d-flex justify-content-center align-items-center p-1 pb-2'>
                    {formData.from && formData.to && formData.to < formData.from && (
                        <Message severity="error" text={<Langs str="ADD_LEAVE_ERROR_DATE" />} />
                    )}
                </Row>
            </Modal.Body>
    }

    function renderHeaderView() {
        return (
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">

                    {selectedLeaveFormData && leaveModalType == 'UPDATE_LEAVE' ?
                        <div className="d-flex align-items-center">
                            <label className="me-2">
                                {getLeaveLabel(selectedLeaveFormData)}
                            </label>
                            <Tag severity={getTagClass(selectedLeaveFormData.status)}>
                                <Langs str={selectedLeaveFormData.status} />
                            </Tag>
                        </div>
                        :
                        (leaveModalType == 'ADD_LEAVE' ?
                            <Langs str={isManager() ? "Add New Leave" : "Request New Leave"} />
                            :
                            <div></div>)
                    }
                </Modal.Title>
            </Modal.Header>
        )
    }

    function renderCollabFooterView() {
        switch (leaveModalType) {
            case "UPDATE_LEAVE":
                if (selectedLeaveFormData["id_collab"] == userId && !['DELETED', 'DELETE_REQUESTED'].includes(selectedLeaveFormData.status))
                    return (
                        <Modal.Footer className="d-flex justify-content-between">
                            <Col md={3}>
                                <PrimaryButton title="CANCEL" active={true} onClick={() => hide()} />
                            </Col>
                            <Col md={5}>
                                <DangerButton
                                    title={selectedLeaveFormData["status"] == "PENDING" ? "DELETE" : "REQUEST_DELETE"}
                                    active={true}
                                    onClick={() => handleRequestDelete()}
                                />
                            </Col>
                        </Modal.Footer>
                    )
                return
            case "ADD_LEAVE":
                return <Modal.Footer className="d-flex justify-content-between">
                    <Col md={3}>
                        <PrimaryButton title="CANCEL" active={true} onClick={() => hide()} />
                    </Col>
                    <Col md={3}>
                        <ThemeButton
                            title="SEND"
                            active={true}
                            onClick={() => handleSend()}
                        />
                    </Col>
                </Modal.Footer>
        }

    }

    function renderAdminFooterView() {
        switch (leaveModalType) {
            case "UPDATE_LEAVE":
                switch (selectedLeaveFormData.status) {
                    case "PENDING":
                        return (<Modal.Footer className="d-flex justify-content-between">
                            <Col md={3}>
                                <DangerButton
                                    title="REJECT"
                                    active={true}
                                    onClick={() => updateLeaveWithStatus('REJECTED')}
                                />
                            </Col>
                            <Col md={3}>
                                <PrimaryButton
                                    title="VALIDATE"
                                    active={true}
                                    onClick={() => updateLeaveWithStatus('VALIDATED')}
                                />
                            </Col>
                        </Modal.Footer>
                        )
                    default:
                        break;
                }
            case "UPDATE_LEAVE":
                if (selectedLeaveFormData.status !== 'DELETED')
                    return (
                        <Modal.Footer className="d-flex justify-content-between">
                            <Col md={3}>
                                <PrimaryButton title="CANCEL" active={true} onClick={() => hide()} />
                            </Col>
                            <Col md={3}>
                                <DangerButton
                                    title="DELETE"
                                    active={true}
                                    onClick={() => updateLeaveWithStatus('DELETED')}
                                />
                            </Col>
                        </Modal.Footer>
                    );
                return
            case "ADD_LEAVE":
                return <Modal.Footer className="d-flex justify-content-between">
                    <Col md={3}>
                        <PrimaryButton title="CANCEL" active={true} onClick={() => hide()} />
                    </Col>
                    <Col md={3}>
                        <ThemeButton
                            title={isManager() ? "ADD" : "SEND"}
                            active={true}
                            onClick={() => handleSend()}
                        />
                    </Col>
                </Modal.Footer>
            default:
                break;
        }
    }

    return (
        <Modal
            {...props}
            onHide={() => hide()}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {renderHeaderView()}
            {renderBodyView()}
            {isOwner(userRoleId) || isManager(selectedLeaveFormData.id_team) ? renderAdminFooterView() : renderCollabFooterView()}
        </Modal>
    )
}
